import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsKitesurfNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M20.46 19.68l-1.13.6-.11.06-1.53.82-.11.05-1.13.61-.21.11-.49.26.63 1.19 5.42-2.88-.64-1.19-.49.26zM16.47.32c-1.777.058-3.518.52-5.09 1.35l-.8.43-3.2 1.7-.8.42a11.715 11.715 0 00-3.96 3.44 4.025 4.025 0 00-.71 3.1 4.069 4.069 0 001.73 2.68l11.33 7.64.53-.29.82-.43.42-.22-9.15-9.86a2.708 2.708 0 01-.36-3.22c.036-.062.077-.122.12-.18a7.894 7.894 0 00-1.84 1.66v.01c.001.27.038.54.11.8L3.261 10.6a.235.235 0 01-.02-.08 2.73 2.73 0 01.47-2.07A11.792 11.792 0 018.26 4.86a10.087 10.087 0 015.12-1.05 2.711 2.711 0 012.46 2.1l3.06 13.07.43-.22.81-.43.53-.28V4.4a4.021 4.021 0 00-1.24-2.92A4.13 4.13 0 0016.47.32zM6.137 10.6v.007a5.2 5.2 0 00.46.59l6.46 6.96L4.4 12.32a2.4 2.4 0 01-.55-.5zm7.323-8.14c-.19-.01-.37-.02-.56-.02 1.148-.47 2.37-.731 3.61-.77a2.704 2.704 0 011.98.77l.04.04-2.361 1.26a4.058 4.058 0 00-2.709-1.28zm5.87 12.4L17.16 5.6a4.47 4.47 0 00-.24-.73l2.3-1.222c.072.243.11.496.11.75z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKitesurfNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsKitesurfNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsKitesurfNormalSmall;
